<div class="op-website-terms" *transloco="let t">
	<div class="op-left with-icon op-gray">
		<mat-icon class="customIconSize" svgIcon="op-popout"></mat-icon>
		<div class="op-ml-5">
			<div class="disclaimerText op-micro-font" [innerHTML]="t('WEBSITE_TERMS.websiteTerms')"></div>
		</div>
	</div>
</div>
